let aiCompetitorsVisitMemory = null;

export const readAiCompetitorsVisit = () => aiCompetitorsVisitMemory;

export const rememberAiCompetitorsVisit = (snapshot) => {
  aiCompetitorsVisitMemory = snapshot;
};

export const clearAiCompetitorsVisit = () => {
  aiCompetitorsVisitMemory = null;
};
